export const isValidColor = (str) => {
  if (str === null || str === undefined) return false

  const hexadecimalColor = /^#([a-f0-9]{6}|[a-f0-9]{8})$/i
  const isValid = str.match(hexadecimalColor) !== null

  return isValid
}
